// Marketplace cart, kept in localStorage so it survives sign-in (browse first, log in to check out).
// Prices here are only for display: the backend prices the order from the catalogue at checkout.

const KEY = "marketplace_cart";
const EVENT = "marketplace-cart";

function read() {
  try {
    const items = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(items) ? items : [];
  } catch (e) {
    return [];
  }
}

function write(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event(EVENT));
}

function snapshot(product) {
  return {
    id: product.id,
    name: product.name,
    unit: product.unit || "piece",
    unit_price: Number(product.unit_price) || 0,
    min_order_quantity: product.min_order_quantity || 1,
    quantity_available: product.quantity_available || 0,
    image: (product.image_urls && product.image_urls[0]) || null,
    vendor: product.vendor ? { id: product.vendor.id, name: product.vendor.name } : { id: product.vendor_id, name: "" },
  };
}

export default {
  EVENT,

  items() {
    return read();
  },

  count() {
    return read().length;
  },

  add(product, quantity) {
    const items = read();
    const qty = Math.max(Number(quantity) || 0, product.min_order_quantity || 1);
    const existing = items.find((i) => i.product.id === product.id);
    if (existing) {
      existing.quantity = Math.min(existing.quantity + qty, product.quantity_available || existing.quantity + qty);
      existing.product = snapshot(product);
    } else {
      items.push({ product: snapshot(product), quantity: qty });
    }
    write(items);
  },

  setQuantity(productId, quantity) {
    const items = read();
    const item = items.find((i) => i.product.id === productId);
    if (item) {
      item.quantity = Math.max(Number(quantity) || 1, 1);
      write(items);
    }
  },

  remove(productId) {
    write(read().filter((i) => i.product.id !== productId));
  },

  removeMany(productIds) {
    write(read().filter((i) => !productIds.includes(i.product.id)));
  },

  clear() {
    write([]);
  },
};
